export default __webpack_public_path__ + "static/media/flag-scotland.13532392.svg";